import { Component } from '@angular/core';
import { LoadingService } from './loading.service';
import { AngularFirestore } from '@angular/fire/compat/firestore';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  loading$ = this.loader.loading$;
  constructor(public loader: LoadingService, store: AngularFirestore) {}

  title = 'WIPWebDash';
}
